import { call, put } from 'redux-saga/effects';
import { Action } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { displaySimpleNotification } from 'features/notifications/simple-notifications/displaySimpleNotification';

export function* onRecordingBookmarkCreatedSaga() {
  const notificationThunk: Action = yield call(displaySimpleNotification, {
    content: i18n.t('notifications:recording.bookmark_added'),
  });

  yield put(notificationThunk);
}
